<template>
  <new-modal-wrapper
    :class="`new-terms-condition-modal-step-${ componentName }`"
    modal-name="newTermsConditionModal"
    :headerTitle="$store.state.translations.data.twoStepsTermsConditionModalHeaderTitle"
    widthModal="100%"
    :heightModal="fullScreen ? '100%' : 'auto'"
    :fullHeight="true"
    ref=newTermsConditionModal
    :cta-primary-button="ctaButtons[componentName]"
    :cta-primary-button-icon-name="ctaButtonIcons[componentName].name"
    :cta-primary-button-icon-type="ctaButtonIcons[componentName].type"
    :max-width-modal="fullScreen ? Infinity : 500"
    :click-to-close="false"
    @cta-action="onCtaAction"
    @go-back="onGoBack"
    @closed="onClose"
    @before-open="beforeOpenModal"
    :modalClasses="modalClasses"
    :type="type"
    :dialogDesc="true"
  >
    <terms-conditions-text
      ref=content
      @showBackButton="showBackButton"
      @showIconButton="showIconButton"
      v-bind="componentAttributes[componentName]"
    ></terms-conditions-text>
    <terms-conditions-form
      ref=content
      @showBackButton="showBackButton"
      @showIconButton="showIconButton"
      @showCtaButton="showCtaButton"
      @blockCtaPrimaryButton="blockCtaPrimaryButton"
      v-bind="componentAttributes[componentName]"
    ></terms-conditions-form>
  </new-modal-wrapper>
</template>
<script>

import newModalWrapper from '@/components/Modals/NewModalWrapper/NewModalWrapper';
import termsConditionsText from '@/components/UGC/Modals/NewTermsConditionModal/components/TermsConditionsText';
import termsConditionsForm from '@/components/UGC/Modals/NewTermsConditionModal/components/TermsConditionsForm';

import { sessionKeys } from '@/data/constants';


export default {
  components: {
    newModalWrapper,
    termsConditionsText,
    termsConditionsForm,
  },
  props: {
    fullScreen: {
      type: Boolean,
      default: false,
    },
    showBackButtonOnMounted: {
      type: Boolean,
      default: false,
    },
    autoOpen: {
      type: Boolean,
      default: false,
    },
    useChooseImageComponent: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'customizer',
    }
  },
  data() {
    return {
      componentName: 'termsConditionsText',


      ctaButtons: {
        termsConditionsText: "termsConditionsNext",
        termsConditionsForm: "termsConditionsAddYourImage"
      },
      ctaButtonIcons: {
        termsConditionsText: {
          name: 'icon-next',
          type: 'svg',
        },
        termsConditionsForm: {
          name: 'camera',
          type: 'icon',
        },
      },
      componentAttributes: {
        termsConditionsText: {
          showBackButton: false,
        },
        termsConditionsForm: {
          useChooseImageComponent: false,
        },
      }
    }
  },
  computed: {
    checkerboarderActive() {
      return this.$store.state.UGCEntryPoint.checkerboarder.active;
    },
    useEcomDataLayerFormat() {
      return this.$store.getters['utils/useEcomDataLayerFormat'];
    },
    modalClasses() {
      const isParentHeight = this.$store.getters['utils/noEsiActive']
        && this.$store.getters['utils/isIframeSameOrigin']
        && this.$store.getters["utils/returnScreenSize"].includes('mobile');

      return isParentHeight ? 'force-top' : '';
    }
  },
  methods: {
    setActiveComponent(componentName) {
      this.componentName = componentName;
    },
    showBackButton(value) {
      this.$refs.newTermsConditionModal.showBackButton(value);
    },
    showIconButton(value) {
      this.$refs.newTermsConditionModal.showIconButton(value);
    },
    showCtaButton(value) {
      this.$refs.newTermsConditionModal.showCtaPrimaryButton(value);
    },
    onCtaAction() {
      if (this.componentName === 'termsConditionsForm') {
        this.$refs.content.$refs.chooseImage.onUploadClick();
      } else if (this.$refs.content.ctaAction) {
        if (this.useEcomDataLayerFormat && !this.checkerboarderActive) {
          this.$ugcDataLayer.logAnalyticsEvent({
            action: 'ugc',
            type: this.$ugcDataLayer.types.termsConditionsNext
          });
        }
        this.$refs.content.ctaAction();
      } else {
        this.$modal.hide('newTermsConditionModal');
      }
    },
    onClose() {
      if (this.useEcomDataLayerFormat){
        this.$ugcEntryPointDataLayer.logAnalyticsEvent({
          action: this.checkerboarderActive ? 'checkerboarder' : 'ugc',
          type: this.$ugcEntryPointDataLayer.types.closeModal
        });
      }
      this.$emit('closed')
    },
    onGoBack() {
      if (this.useEcomDataLayerFormat){
        this.$ugcEntryPointDataLayer.logAnalyticsEvent({ action: this.checkerboarderActive ? 'checkerboarder' : 'ugc', type: this.$ugcEntryPointDataLayer.types.backModal });
      }
      this.$modal.hide('newTermsConditionModal');
    },
    blockCtaPrimaryButton(block) {
      this.$refs.newTermsConditionModal.blockCtaPrimaryButton(block);
    },
    beforeOpenModal() {
      if (!this.$cookies.get(sessionKeys.ugcContactDetailsFilled)) {
        this.$store.commit('UGCEntryPoint/RESET_CONTACT_DETAILS');
      }
    }
  },
  created() {
    if (this.showBackButtonOnMounted) {
      this.componentAttributes.termsConditionsText.showBackButton = true;
    }
    if (this.useChooseImageComponent) {
      this.componentAttributes.termsConditionsForm.useChooseImageComponent = true;
    }
  },
  mounted() {
    // Getcontact form data from cookie if exists;
    const userData = this.$cookies.get(sessionKeys.ugcContactDetailsFilled);
    if (!!userData) {
      this.$store.commit('UGCEntryPoint/SET_CONTACT_DETAILS', userData);
    }
    if (!!this.$store.state.UGCEntryPoint.activeView) {
      this.componentName = 'termsConditionsForm';
    }
    if (this.autoOpen) this.$modal.show('newTermsConditionModal');
  },
}
</script>
